import { useQuery } from 'react-query';
import request from '../../../helpers/request';

const createKey = (infoId) => ['infoHeaderImg', infoId];

const fetch = (infoId) =>
  request.get(
    `/Information/${infoId}/image`,
    {},
    'Не удалось получить шапку информирования'
  );

const useFetch = (infoId, options) =>
  useQuery(createKey(infoId), () => fetch(infoId), options);

const infoHeaderImgQuery = { createKey, fetch, useFetch };

export default infoHeaderImgQuery;
